import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import DropDown from "@components/ui/dropdown/DropDown";
import { sample_photos, sample_repertorys } from "@screens/sampleData";
import CheckBoxInput from "@components/ui/selection/CheckBoxInput";
import { SwitchBrick } from "@components/ui/selection/SwitchBrick";
import Button from "@components/ui/buttons/Button";
import Dropzone from "@components/ui/blocks/Dropzone";
import { useState } from "react";
import TextField from "@components/ui/textfields/TextField";
import DatePicker from "@components/ui/selection/DatePicker";
import AreaTextField from "@components/ui/textfields/AreaTextField";
import { orgMembersToUsers } from "@components/ui/blocks/MemberAssignmentBlock";
import { SignatureBlock } from "@components/ui/blocks/SignatureBlock";
import { useDataStore } from "@store/user_org";

export const GenerateFileModal = ({ onClose }: { onClose: () => void }) => {
  const orgMembers = useDataStore((state) => state.orgMembers);
  const orgUsers = orgMembersToUsers(orgMembers);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);
  const [selectedRepertory, setSelectedRepertory] = useState<string>(
    sample_repertorys[0],
  );
  const [conductor, setConductor] = useState<string>(orgUsers[0]?.id || "");
  const [electronicSignature, setElectronicSignature] =
    useState<boolean>(false);
  const [internalDocument, setInternalDocument] = useState<boolean>(false);
  return (
    <BaseModal
      title="Générer un document"
      startIcon={<Icon1 name="file" size={20}></Icon1>}
      onClose={onClose}
    >
      <div className="bg-white flex flex-col gap-2 p-4 ">
        <div className="flex flex-row gap-2">
          <TextField
            label="Titre du document"
            placeholder="Compte rendu MAXIMUS W."
          />
          <TextField label="Nom" placeholder="DUPONT Martin et Célia" />
        </div>
        <div className="flex flex-row gap-2">
          <TextField label="Ville" placeholder="Rennes" />
          <TextField label="Code postal" placeholder="35000" />
        </div>
        <div className="flex flex-row gap-2">
          <TextField label="Adresse" placeholder="1 rue des fleurs" />
          <DatePicker label="Date"></DatePicker>
        </div>
        <DropDown
          options={orgUsers.map((r) => ({
            value: r.id,
            label: r.name,
          }))}
          label="Conducteur de travaux"
          value={conductor}
          onSelect={(value) => {
            setConductor(value as string);
          }}
        ></DropDown>
        <DropDown
          options={sample_repertorys.map((r) => ({
            value: r,
            label: r,
          }))}
          label="Choisir un répertoire"
          value={selectedRepertory}
          onSelect={(value) => {
            setSelectedRepertory(value as string);
          }}
        ></DropDown>
        <AreaTextField
          label="Contenu"
          placeholder="Les travaux de gros oeuvre sont en cours conformément au planning prévisionnel."
        ></AreaTextField>
        <div className="flex flex-wrap max-w-full gap-2 mt-2">
          {sample_photos.map((doc, docIndex) => (
            <img
              key={docIndex}
              src={doc.file.url}
              className="rounded-xl w-36 h-24 object-cover cursor-pointer"
            ></img>
          ))}
        </div>
        <div className="flex flex-row gap-2 w-full">
          <SignatureBlock></SignatureBlock>
          <SignatureBlock></SignatureBlock>
        </div>
      </div>
      <div className="border-t-1 p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onClose}>
          Annuler
        </SecondaryButton>
        <SecondaryButton
          startIcon={<Icon1 name="eye" size={18}></Icon1>}
          variant="small"
          onClick={onClose}
        >
          Aperçu
        </SecondaryButton>
        <Button variant="small" label="Enregistrer"></Button>
      </div>
    </BaseModal>
  );
};
